import TYPES from '../../action-types';

/**
 * Add keyword to assets immediately
 * @param {string[]} ids
 * @param {Object} keyword
 */
const attachedKeyword = (ids, keywords, userId) => (dispatch) => {
  dispatch({
    type: TYPES.ASSETS.ATTACH_KEYWORDS.COMPLETE,
    payload: {
      ids,
      keywords,
      notify: true,
      userId,
    },
  });
};

export default attachedKeyword;
